if (!customElements.get('gallery-slider')) {

const GALLERY_SLIDER_CLASS_NAMES = {
  container: 'gallery-slider__container',
  slide: 'gallery-slider__slide',
  activeSlide: 'gallery-slider__slide--is-active',
  indicator: 'gallery-slider__indicator',
  activeIndicator: 'gallery-slider__indicator--is-active',
  nextButton: 'gallery-slider__control--next',
  previousButton: 'gallery-slider__control--prev'
}

class GallerySlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this.querySelector(`.${GALLERY_SLIDER_CLASS_NAMES.container}`);
    this.slideCount = Number.parseInt(this.querySelector('[data-gallery-total-slides]').textContent);
    this.currentJump = false;

    this.onMouseDownHandler = this.onMouseDown.bind(this);
    this.onMouseUpHandler = this.onMouseUp.bind(this);
    this.onMouseMoveHandler = this.onMouseMove.bind(this);
    this.previousHandler = this.previous.bind(this);
    this.nextHandler = this.next.bind(this);
      this.indicatorHandler = this.indicatorClick.bind(this);
      this.scrollHandler = this.handleScroll.bind(this);

      document.addEventListener('mousedown', this.onMouseDownHandler);

      this.querySelector(`.${GALLERY_SLIDER_CLASS_NAMES.previousButton}`).addEventListener('click', this.previousHandler);
      this.querySelector(`.${GALLERY_SLIDER_CLASS_NAMES.nextButton}`).addEventListener('click', this.nextHandler);
      this.container.addEventListener('scroll', this.scrollHandler);

      const indicators = this.querySelectorAll(`.${GALLERY_SLIDER_CLASS_NAMES.indicator}`);

      indicators.forEach((indicator) => {
        indicator.addEventListener('click', this.indicatorHandler);
      });

      if (this.slideCount > 2) {
        this.cloneSlides();
      }

      this.position = {
        top: 0,
        left: 0,
        x: 0,
        y: 0,
      }

      const observer = new IntersectionObserver(entries => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const slideId = entry.target.getAttribute('data-gallery-slide');
            const goToId = entry.target.getAttribute('data-gallery-go-to-slide');
            
            if (slideId) {
              this.currentJump = false;
              this.activateSlide(slideId);
            } else if (goToId) {
              this.currentJump = goToId;
            }
          }
        });
      }, {
        root: this.container,
        rootMargin: '0% -50% 0% -50%',
      });
      
      const targets = `.${GALLERY_SLIDER_CLASS_NAMES.slide}`;
      this.querySelectorAll(targets).forEach((target) => {
        if (!target) {
          return;
        }
        observer.observe(target);
      });
    }

    disconnectedCallback() {
      document.removeEventListener('mousedown', this.onMouseDownHandler);
    }

    activateSlide(id) {
      const previouslyActiveSlide = this.querySelector(`.${GALLERY_SLIDER_CLASS_NAMES.activeSlide}`);
      const previouslyActiveIndicator = this.querySelector(`.${GALLERY_SLIDER_CLASS_NAMES.activeIndicator}`);

      if (previouslyActiveSlide) {
        previouslyActiveSlide.classList.remove(GALLERY_SLIDER_CLASS_NAMES.activeSlide);
      }

      if (previouslyActiveIndicator) {
        previouslyActiveIndicator.classList.remove(GALLERY_SLIDER_CLASS_NAMES.activeIndicator);
      }

      const slide = this.querySelector(`[data-gallery-slide="${id}"]`);
      const indicator = this.querySelector(`[data-gallery-slider-control="${id}"]`);
      const currentSlide = this.querySelector(`[data-gallery-current-slide]`);

      slide.classList.add(GALLERY_SLIDER_CLASS_NAMES.activeSlide);
      indicator.classList.add(GALLERY_SLIDER_CLASS_NAMES.activeIndicator);
      currentSlide.innerHTML = id;
    }

    previous() {
      const currentSlideElement = this.querySelector(`[data-gallery-current-slide]`);
      const currentSlide = Number.parseInt(currentSlideElement.innerHTML);
      
      if (currentSlide > 1) {
        this.jump(currentSlide - 1);
      } else {
        this.jump(this.slideCount);
      }
    }

    next() {
      const currentSlideElement = this.querySelector(`[data-gallery-current-slide]`);
      const currentSlide = Number.parseInt(currentSlideElement.innerHTML);
      
      if (currentSlide < this.slideCount) {
        this.jump(currentSlide + 1);
      } else {
        this.jump(1);
      }
    }

    indicatorClick(event) {
      const slideId = event.target.getAttribute('data-gallery-slider-control');

      if (!slideId) {
        return;
      }

      this.jump(slideId);
    }

    handleScroll(event) {
      const atSnappingPoint = this.container.scrollLeft % event.target.offsetWidth === 0;
      const timeOut = atSnappingPoint ? 0 : 100;
      clearTimeout(event.target.scrollTimeout);
      event.target.scrollTimeout = setTimeout(() => {
        if (this.currentJump) {
          this.jump(this.currentJump);
        }
      }, timeOut);
    }

    jump(slideId) {
      const nextSlideElement = this.querySelector(`[data-gallery-slide="${slideId}"]`);
      const offset = (this.container.offsetWidth - nextSlideElement.offsetWidth) / 2;
      this.container.scrollTo({left: nextSlideElement.offsetLeft - offset, behavior: 'instant'});
    }

    cloneSlides() {
      const firstSlideElement = this.querySelector(`[data-gallery-slide="1"]`).cloneNode(true);
      const secondSlideElement = this.querySelector(`[data-gallery-slide="2"]`).cloneNode(true);
      const secondLastSlideElement = this.querySelector(`[data-gallery-slide="${this.slideCount - 1}"]`).cloneNode(true);  
      const lastSlideElement = this.querySelector(`[data-gallery-slide="${this.slideCount}"]`).cloneNode(true);

      firstSlideElement.removeAttribute('data-gallery-slide');
      firstSlideElement.setAttribute('data-gallery-go-to-slide', '1');
      lastSlideElement.removeAttribute('data-gallery-slide');
      lastSlideElement.setAttribute('data-gallery-go-to-slide', `${this.slideCount}`);

      this.container.prepend(lastSlideElement);
      this.container.append(firstSlideElement);

      if (secondSlideElement) {
        secondSlideElement.removeAttribute('data-gallery-slide');
        secondSlideElement.setAttribute('data-gallery-go-to-slide', '2');
        this.container.append(secondSlideElement);
      }

      if (secondLastSlideElement) {
        secondLastSlideElement.removeAttribute('data-gallery-slide');
        secondLastSlideElement.setAttribute('data-gallery-go-to-slide', `${this.slideCount - 1}`);
        this.container.prepend(secondLastSlideElement);
      }

      this.jump(1);
    }

    onMouseDown(event) {
      if (!this.container.contains(event.target)) {
        return;
      }

      this.position = {
        left: this.container.scrollLeft,
        top: this.container.scrollTop,
        x: event.clientX,
        y: event.clientY,
      };

      this.container.style.scrollSnapType = 'none';
      this.container.style.userSelect = 'none';

      document.addEventListener('mousemove', this.onMouseMoveHandler);
      document.addEventListener('mouseup', this.onMouseUpHandler);
    }


    onMouseUp() {
      document.removeEventListener('mousemove', this.onMouseMoveHandler);
      document.removeEventListener('mouseup', this.onMouseUpHandler);
      this.container.style.scrollSnapType = 'x mandatory';
      this.container.style.removeProperty('user-select');
    };

    onMouseMove(event) {
      // Calculate how far the mouse has been moved
      const dx = event.clientX - this.position.x;
      const dy = event.clientY - this.position.y;

      // Scroll the element
      this.container.scrollTop = this.position.top - dy;
      this.container.scrollLeft = this.position.left - dx;
    }
  }

  customElements.define('gallery-slider', GallerySlider);
}
